import { render } from "./LoginErrorPage.vue?vue&type=template&id=0c79271b"
import script from "./LoginErrorPage.vue?vue&type=script&lang=js"
export * from "./LoginErrorPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__